export default __webpack_public_path__ + "static/media/Jama-Masjid.3a5ba47c.jpg";